import { useApiQuery, useApiMutation } from "../services/react-query";

export const useCreateRegistrationTicketType = () => {
  return useApiMutation({
    fetchOptions: {
      url: "/registration-ticket-types",
      method: "POST",
    },
    successMessage: {
      title: "Registration Ticket Type was created successfully",
    },
    invalidateQueryKeys: [["registrationTicketTypes"]],
  });
};

export const useGetAllRegistrationTicketTypeForEvent = (eventId) => {
  return useApiQuery({
    queryOptions: { queryKey: ["registrationTicketTypes", eventId] },
    fetchOptions: {
      url: `/registration-ticket-types/${eventId}`,
      method: "GET",
    },
  });
};

export const useUpdateRegistrationTicketType = (id) => {
  return useApiMutation({
    fetchOptions: {
      url: `/registration-ticket-types/${id}`,
      method: "PATCH",
    },
    successMessage: {
      title: "Registration Ticket Type was updated successfully",
    },
    invalidateQueryKeys: [["registrationTicketTypes"]],
  });
};

export const useDeleteRegistrationTicketType = (id) => {
  return useApiMutation({
    fetchOptions: {
      url: `/registration-ticket-types/${id}`,
      method: "DELETE",
    },
    successMessage: {
      title: "Registration Ticket Type was deleted successfully",
    },
    invalidateQueryKeys: [["registrationTicketTypes"]],
  });
};
